import { HttpService, ObservableCollection, Repository, RepositoryBase, TaggedUrl, Tags, Weaver } from '@skylab-shared/core';
import {
    FiscalDeviceModel, FiscalDevicePaymentMethodsParametersMappingModel, FiscalDevicePaymentMethodsParametersModel, FiscalDeviceVatRatesParametersMappingModel, FiscalDeviceVatRatesParametersModel
} from '@skylab-shared/dataModel';
import { isUndefined, pickBy } from '@skylab-shared/utils';
import { FiscalDeviceBO } from './fiscal-device.bo';

@Repository({
    boType: FiscalDeviceBO,
    apiController: TaggedUrl.join('system/devices', [Tags.Api])
})
export class FiscalDeviceRepositoryBase extends RepositoryBase<FiscalDeviceBO, FiscalDeviceModel> {
    public constructor(
        private readonly weaver: Weaver,
        $http: HttpService,
    ) {
        super($http);
    }

    protected createBO(): FiscalDeviceBO {
        return new FiscalDeviceBO(this.weaver);
    }

    protected async preparePlainObjectAsync(model: FiscalDeviceModel): Promise<any> {
        const data: any = {
            id: model.id,
            version: model.version,
            default: model.default,
            name: model.name,
        };

        if (model.vatRatesParameters) {
            const mappings = model.vatRatesParameters.mappings.map(m => {
                return {
                    mapped: m.mapped,
                    id: m.vatRateId,
                };
            });
            data.vatRatesParameters = {
                technicalZero: model.vatRatesParameters.technicalZero,
                mappings: mappings
            };
        }

        if (model.paymentMethodsParameters) {
            const mappings = model.paymentMethodsParameters.mappings.map(m => {
                return {
                    mapped: m.mapped,
                    id: m.paymentMethodId
                };
            });
            data.paymentMethodsParameters = {
                mappings: mappings
            };
        }
        return data;
    }

    protected async fromPlainObjectAsync(item: any): Promise<FiscalDeviceModel> {
        let paymentMethodsParameters = null;
        if (item.paymentMethodsParameters) {
            const mappings = new ObservableCollection<FiscalDevicePaymentMethodsParametersMappingModel>();
            item.paymentMethodsParameters.mappings.forEach((m: any) => {
                mappings.push(new FiscalDevicePaymentMethodsParametersMappingModel({
                    mapped: m.mapped,
                    paymentMethodId: m.id
                }));
            });
            paymentMethodsParameters = new FiscalDevicePaymentMethodsParametersModel({
                mappings: mappings
            });
        }
        let vatRatesParameters = null;
        if (item.vatRatesParameters) {
            const mappings = new ObservableCollection<FiscalDeviceVatRatesParametersMappingModel>();
            item.vatRatesParameters.mappings.forEach((m: any) => {
                mappings.push(new FiscalDeviceVatRatesParametersMappingModel({
                    mapped: m.mapped,
                    vatRateId: m.id,
                    value: isUndefined(m.value) ? null : m.value
                }));
            });
            vatRatesParameters = new FiscalDeviceVatRatesParametersModel({
                mappings: mappings,
                technicalZero: isUndefined(item.vatRatesParameters.technicalZero) ? null : item.vatRatesParameters.technicalZero,
            });
        }
        return new FiscalDeviceModel(pickBy({
            id: item.id,
            version: item.version,
            sun: item.sun,

            default: item.default,
            name: item.name,
            paymentMethodsParameters: paymentMethodsParameters,
            vatRatesParameters: vatRatesParameters
        }, val => val !== void 0));
    }
}
